import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';

import { userIdentityShape } from '@bibliocommons/bc-prop-types';
import UserAvatar from '@bibliocommons/user-avatar';
import UserStaffStamp from 'app/components/shelves/ShelfHeader/StaffStamp';

import './UserHeader.scss';

class UserHeader extends React.PureComponent {
  renderUserStaffStamp() {
    const { userIdentity } = this.props;

    if (userIdentity.get('staff')) {
      return <UserStaffStamp inverse />;
    }

    return null;
  }

  render() {
    const { renderActions, userIdentity, renderNav } = this.props;
    const classNames = cn('cp-user-header', {
      'home-patron': userIdentity.get('homePatron')
    });

    return (
      <div className={classNames}>
        <div className="user-header-top">
          <div className="row">
            <div className="col-12 col-xs-12 col-sm-8">
              <div className="row">
                <div className="col-md-8">
                  <div className="pull-left user-header-avatar">
                    <UserAvatar userIdentity={userIdentity} size="lg" />
                  </div>

                  <div className="pull-left user-header-info">
                    <div className="user-header-username">{userIdentity.get('name')}</div>
                    <div className="user-header-library">
                      {this.renderUserStaffStamp()}
                      {userIdentity.get('homeLibraryFullName')}
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="user-header-about">{/* TODO: Display profile.about */}</div>
                </div>
              </div>
            </div>

            <div className="col-12 col-xs-12 col-sm-4">
              <div className="user-header-actions">{renderActions()}</div>
            </div>
          </div>
        </div>

        <div className="user-header-bottom">{renderNav()}</div>
      </div>
    );
  }
}

UserHeader.propTypes = {
  renderActions: PropTypes.func,
  renderNav: PropTypes.func,
  userIdentity: userIdentityShape.isRequired
};

UserHeader.defaultProps = {
  renderActions: () => null,
  renderNav: () => null
};

export default UserHeader;
